import { makeAssetReducer } from './reducer-helpers';
import { SEARCH_ASSETS } from '../bridge-method-remap';
export default makeAssetReducer(SEARCH_ASSETS);



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/assetGroups/reducer-search.js